import React, { useEffect } from 'react';
import { getNowTime } from '@service/common';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import { LxModuleView } from '@utils/siteLx';
import { useRootStore } from '@model/index';
import { SECTION_NAME_MAP } from '@src/enums/content';
// import { focusList } from '../../Router/const';
import { useSafeState } from 'ahooks';
import './index.scss';

function Footer() {
  const {
    cmsData: { cmsData, getSectionByName },
  } = useRootStore();

  const { email } = cmsData?.globalConfig || {};
  const focusList = getSectionByName(SECTION_NAME_MAP.focusList) || [];

  const [nowYear, setNowYear] = useSafeState('2024');
  useEffect(() => {
    (async () => {
      try {
        // 记录字体为undefined的情况数量
        const dom = document.getElementsByClassName('slogan_cn');
        if (dom && dom.length > 0) {
          const sloganCnStyle = window.getComputedStyle(dom[0]);
          if (sloganCnStyle && !sloganCnStyle.fontFamily) {
            LxModuleView({ bid: 'b_ead_gspxsx8k_mv' });
          }
        }
        // 获取服务器时间
        const nowTime = await getNowTime();
        if (nowTime) {
          setNowYear(dayjs(nowTime as number).format('YYYY'));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  return (
    <div className="zp_footer">
      <div className="content">
        <div className="logoAndSlogan">
          <div>
            <img className="logo" src={require('@imgs/logo.png')} alt="美团招聘logo" />
          </div>
          <div className="slogan">
            <p className="slogan_cn">一起成长，一起更好</p>
            <p className="slogan_en">Grow Together, Better Together</p>
          </div>
        </div>
        <div className="copyAndFocusUs">
          <div className="copy">
            <div className="copyText">
              <span>
                <a className="meituanUrl" href="https://www.meituan.com">
                  美团
                </a>
              </span>
              <span className="line">|</span>
              <span className="meituanCopy">@{nowYear} 美团版权所有</span>
              <span>
                <a className="num1" href="https://beian.miit.gov.cn/">
                  京ICP备10211739号
                </a>
              </span>
              <span className="num2Wrap">
                <i className="icon" />
                <a className="num2" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002002052">
                  京公网安备 11000002002052号
                </a>
              </span>
              <span className="line">|</span>
              <span>
                <a className="rule" href="https://rules-center.meituan.com/rules-detail/2">
                  隐私政策
                </a>
              </span>
              <span className="contact">&nbsp;&nbsp;&nbsp;&nbsp;招聘意见反馈：{email}</span>
            </div>
          </div>
          <div className="focusUsWrap">
            <div className="focus_us">
              <span className="subcribeText">关注我们</span>
              {Array.isArray(focusList) &&
                focusList.map((item) => (
                  <div
                    key={item.code}
                    rel="nofollow"
                    className="img_wrapper subcribeImg cursor_pointer"
                    onClick={() => {
                      if (item.linkUrl && item.linkUrl !== '/') {
                        window.open(item.linkUrl);
                      }
                    }}
                    style={{
                      backgroundImage: `url(${item.icon})`,
                    }}
                  >
                    <div className="erwei_wrapper cursor_pointer">
                      <div className="erwei_wrapper_content">
                        <div className="qr_code">
                          <img src={item.imgUrl} alt="" />
                        </div>
                        <div className="text">{item.secondTitle}</div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Footer);
